import Quagga from 'quagga';
import Swal from 'sweetalert2';

import '../elements/cart/cart-add-update-delete';

var timeoutId;
var parent_container = document.querySelector('.load');
var scanbutton = document.getElementById('scancode');
var uploadbutton = document.getElementById('uploadcode');
var imageLoader = document.getElementById('imageLoader'); //input

//clicking the scanbutton
scanbutton.addEventListener('click', function onClick(e) {
    e.preventDefault();
    //trigger input file to load image
    open_realtime_scan();
});

//clicking the uploadbutton
uploadbutton.addEventListener('click', function onClick(e) {
    e.preventDefault();
    //trigger input file to load image
    imageLoader.click();
});

//Trigger quagga on input chage to search for barcode
imageLoader.addEventListener('change', handleImage, false);

//when you upload trough input read image
function handleImage(e) {
    var reader = new FileReader();
    reader.onload = function (event) {
        Quagga.decodeSingle({
            decoder: {
                readers: [
                    'code_128_reader',
                    'ean_reader',
                    'ean_8_reader',
                ],
            },
            locate: true, // try to locate the barcode in the image
            src: (event.target).result,
        }, function (result) {
            if (result.codeResult) {
                document.querySelector('input#search_isbn_name').value = result.codeResult.code;
                autosearch(result.codeResult.code);
            } else {
                Swal.fire(
                    'Scannen',
                    'no code detected',
                    'error',
                );
            }
        });

    };
    reader.readAsDataURL(e.target.files[0]);
}

//Trigger real time scan
function open_realtime_scan() {
    //Show realtime canvas
    document.querySelector('.scanner-wrapper').classList.add('active');

    Quagga.init({
        inputStream: {
            name: 'Live',
            type: 'LiveStream',
            target: document.getElementById('live_scanner'),
        },
        locator: {
            patchSize: 'medium',
            halfSample: true,
        },
        numOfWorkers: (navigator.hardwareConcurrency ? navigator.hardwareConcurrency : 4),
        decoder: {
            readers: [
                'code_128_reader',
                'ean_reader',
                'ean_8_reader',
            ],
        },
        locate: true, // try to locate the barcode in the image
    }, function (err) {
        if (err) {
            console.error('ERRORINFO: SetUp von QuaggaJS');
            console.error(err);

            //Stop and close the scanner
            stop_and_close_scanner();

            Swal.fire({
                title: 'Scannen',
                html: 'Het is niet mogelijk de camera te starten <br/> Gelieve de code te uploaden.',
                icon: 'error',
                confirmButtonText: 'Supercool <i class="fas fa-mask ml-2"></i>',
            });

            //show upload button instead
            uploadbutton.classList.remove('d-none');
            scanbutton.classList.add('d-none');

            return;
        }
        console.log('Initialization finished. Ready to start');
        Quagga.start();
    });

    Quagga.onProcessed(function (result) {

        var drawingCtx = Quagga.canvas.ctx.overlay,
            drawingCanvas = Quagga.canvas.dom.overlay;

        if (result) {
            if (result.boxes) {
                drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')), parseInt(drawingCanvas.getAttribute('height')));
                result.boxes.filter(function (box) {
                    return box !== result.box;
                }).forEach(function (box) {
                    Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: 'green', lineWidth: 2});
                });
            }

            if (result.box) {
                Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: '#00F', lineWidth: 2});
            }

            if (result.codeResult && result.codeResult.code) {
                Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
            }
        }
    });

    Quagga.onDetected(function (result) {
        document.querySelector('input#search_isbn_name').value = result.codeResult.code;
        autosearch(result.codeResult.code);

        //Stop and close the scanner
        stop_and_close_scanner();
    });

    timeoutId = setTimeout(function () {
        var close_button = document.createElement('BUTTON');
        close_button.innerHTML = '<i class="far fa-times fa-2x"></i>';
        close_button.classList.add('close');
        close_button.onclick = function () {
            stop_and_close_scanner();
        };
        document.getElementById('live_scanner').appendChild(close_button);
    }, 600);

    function stop_and_close_scanner() {
        Quagga.stop();
        document.getElementById('live_scanner').innerHTML = '';
        document.querySelector('.scanner-wrapper').classList.remove('active');
    }
}


//Autosearch after change is detectect on input
document.querySelector('#search_isbn_name').oninput = function () {
    autosearch($(this).val());
};

function autosearch(search) {
    // If a timer was already started, clear it.
    if (timeoutId) {
        clearTimeout(timeoutId);
    }

    document.getElementById('mylibrary-spinner').classList.remove('d-none');

    // Set timer that will call ajax when your stop typing.
    timeoutId = setTimeout(function () {
        var data = 'search=' + search;

        var xhr = new XMLHttpRequest();
        xhr.open('POST', strAjaxPath + 'mylibrary-autosuggest.php', true);
        xhr.onload = function () {
            document.getElementById('mylibrary-spinner').classList.add('d-none');

            if (xhr.status === 200) {
                //Success
                $('.suggestion').html(xhr.responseText);

                var books = document.querySelectorAll('.addToLibrary');
                for (var i = 0; i < books.length; i++) {
                    //Clicking on a book from the autosuggest add the book to my library
                    books[i].onclick = function () {
                        updateMyLibrary(this.getAttribute('data-id'), 'add');
                    };
                }
            } else {
                //Show error
                Swal.fire(
                    'error',
                    'xhr status: ' + xhr.status,
                    'error',
                );
            }
        };
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.send(data);
    }, 500);
}


document.addEventListener('DOMContentLoaded', function () {
    //Search in your library
    var search_input = document.getElementById('searchmylibrary');
    if (search_input) {
        search_input.oninput = function () {
            var search = this.value;

            // If a timer was already started, clear it.
            if (timeoutId) {
                clearTimeout(timeoutId);
            }

            // Set timer that will call ajax when your stop typing.
            timeoutId = setTimeout(function () {
                //Show fullscreen loader
                var loader = document.querySelector('.overlay-loader');
                loader.classList.remove('d-none');
                loader.classList.add('d-flex');


                var data =
                    'search=' + encodeURIComponent(search) +
                    '&itemno=' + encodeURIComponent(document.getElementById('page_id').value) +
                    '&filterload=1';

                //--Url wijzigen
                var urlParams = new URLSearchParams(window.location.search);
                var page = urlParams.get('page');

                var str = window.location.search;
                var tmp_url = str.substr(1);


                //Splitting it with : as the separator
                var filters = tmp_url.split('&');
                //Add filter to data
                for (var i = 0; i < filters.length; i++) {
                    if (!filters[i].lastIndexOf('search', 0) === 0) {
                        data += '&' + filters[i];
                    }
                }

                str = replaceQueryParams('search', search, str);
                if (page !== null && page > 0) {
                    str = replaceQueryParams('page', page, str);
                }

                str = window.location.pathname + str;
                window.history.pushState({path: str}, '', str);


                var xhr = new XMLHttpRequest();
                xhr.open('GET', 'mylibrary?' + data, true);
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        //Success
                        // $('.load').html(xhr.responseText);
                        //Herladen van linkerkant
                        LoadArticles();
                    } else {
                        //Show error
                        Swal.fire(
                            'error',
                            'xhr status: ' + xhr.status,
                            'error',
                        );
                    }

                    //hide fullscreen loader
                    loader.classList.add('d-none');
                    loader.classList.remove('d-flex');
                };
                xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                xhr.send();
            }, 500);
        };
    }


    //Handle click event on parent element (load)
    if (parent_container) {
        parent_container.addEventListener('click', function (e) {
            //path = chrome, compsedpath = ff, fallback ie
            var path = e.path || (e.composedPath && e.composedPath() || composedPath(e.target));
            if (path) {
                for (var i = 0; i < path.length; i++) {
                    var element = path[i];

                    if (element.getAttribute) {
                        //Change view
                        if (element.getAttribute('data-id') === 'view') {
                            change_view(element.getAttribute('data-view'));
                            break;
                        }

                        //Delete book from mylibrary
                        if (element.getAttribute('data-type') === 'deletebook') {
                            e.preventDefault();
                            e.stopPropagation();
                            delete_book(element.getAttribute('data-id'));
                            break;
                        }
                    }
                }
            }
        });
    }


    //When changing serie to order change price
    $('.load').on('change', '#seriestype', function () {
        $('#priceseries span').html($(this).val());
    });

    //Order the series
    $('.load').on('click', '#order_series', function () {
        var button = $(this);
        var strParams = 'strProductsFull=' + $('#seriestype option:selected').data('articles');

        button.find('i[class*="shopping"]').addClass('d-none');
        button.find('i[class*="spinner"]').removeClass('d-none');

        // Add items to cart
        $.post(strAjaxPath + 'cart/cart.php', strParams, function (data) {
            button.find('i[class*="spinner"]').addClass('d-none');
            button.find('i[class*="check"]').removeClass('d-none');

            // Update mini cart in pagehead
            UpdateMiniCart();

            $('#MyLibrarySeries').modal('hide');
        }, 'json');
    });

    $('form.form-add-to-cart button.btn-basket').click(function () {
        var objButton = $(this);
        var objForm = $(this).parents('form:first');

        AddProductToCart(objForm, objButton, false, true);
    });
});

//Delete book from mylibrary
function delete_book(element) {
    //Show confirmation first
    Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
        if (result.value) {
            //Remove book
            updateMyLibrary(element, 'remove');
        }
    });
}

//Update view
function change_view(element) {
    //Show fullscreen loader
    var loader = document.querySelector('.overlay-loader');
    loader.classList.remove('d-none');
    loader.classList.add('d-flex');

    var data = 'value=' + element;

    var xhr = new XMLHttpRequest();
    xhr.open('POST', strAjaxPath + 'catalog-view.php', true);
    xhr.onload = function () {
        if (xhr.status === 200) {
            //Success
            reloadPage(false);
        } else {
            //Show error
            Swal.fire(
                'error',
                'xhr status: ' + xhr.status,
                'error',
            );
        }

        //hide fullscreen loader
        loader.classList.add('d-none');
        loader.classList.remove('d-flex');
    };
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.send(data);
}


//After form submit call ajax to add own book
function add_own_book(event) {
    //Check if it's the right form
    if (event.srcElement.getAttribute('id') === 'addOwnBook') {
        event.preventDefault();
        event.stopPropagation();

        //Add a new book to your library
        updateMyLibrary(0, 'add');
    }
}

//Add books to your library
function updateMyLibrary(book_id, type) {
    //Show fullscreen loader
    var loader = document.querySelector('.overlay-loader');
    loader.classList.remove('d-none');
    loader.classList.add('d-flex');

    var data =
        'book_id=' + book_id +
        '&type=' + type;

    //When there is no book_id add own book
    if (book_id === 0) {

        //Get all images
        var images = document.getElementById('previewImages').childNodes;

        //Put data src from image in array
        for (var i = 0; i < images.length; i++) {
            data += '&book_images[]=' + encodeURIComponent(images[i].src);
        }

        data +=
            '&book_name=' + encodeURIComponent(document.getElementById('book_name').value) +
            '&book_isbn=' + encodeURIComponent(document.getElementById('book_isbn').value) +
            '&book_description=' + encodeURIComponent(document.getElementById('book_description').value) +
            // '&book_price=' + encodeURIComponent(document.getElementById('book_price').value) +
            '&book_series=' + encodeURIComponent(document.getElementById('book_series').value);
    }

    var xhr = new XMLHttpRequest();
    xhr.open('POST', strAjaxPath + 'mylibrary.php', true);
    xhr.onload = function () {
        if (xhr.status === 200) {
            var responsedata = JSON.parse(xhr.responseText);
            if (responsedata.success == true) {
                Swal.fire({
                    icon: 'success',
                    title: responsedata.data.message,
                    showConfirmButton: false,
                    timer: 1500,
                }).then((result) => {
                    if (result.dismiss === Swal.DismissReason.timer) {
                        //Reload page
                        location.reload();
                    }
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: responsedata.data.message,
                    showConfirmButton: true,
                });
            }
        } else {
            //Show error
            Swal.fire(
                'error',
                'xhr status: ' + xhr.status,
                'error',
            );
        }

        loader.classList.add('d-none');
        loader.classList.remove('d-flex');
    };
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.send(data);
}

//Reload page with ajax
function reloadPage(blnReset) {
    if (blnReset == undefined) {
        blnReset = false;
    }
    if (window.location.href.indexOf('?') <= -1) {
        blnReset = true;
    }

    //-- Ophalen van de producten
    var strFilterLoad = '';
    if (blnReset === true) {
        strFilterLoad = '?filterload=1';
    } else {
        strFilterLoad = '&filterload=1';
    }

    var strUrl = window.location.href;
    strUrl = strUrl.replace('#', '');

    $('.load').load(strUrl + strFilterLoad, function () {
    });
}


document.getElementById('filImages').onchange = function () {
    var files = [];
    var exceeded = '';
    var filecontainer = document.getElementById('previewImages');


    for (var i = 0; i < this.files.length; i++) {
        //Filter out files that are to large (max 2mb)
        if (this.files[i].size > 2000000) {
            var sizeinmb = this.files[i].size / 1000000;
            exceeded += this.files[i].name + ' (' + sizeinmb.toFixed(2) + 'Mb)<br/>';
        } else {
            files[i] = this.files[i];
        }
    }

    //Show error if file limit has exceeded for some files
    if (exceeded !== '') {
        Swal.fire({
            title: 'error',
            html: 'Maximum filesize exceeded of 2MB for following files: <br/>' + exceeded,
            icon: 'error',
        });
    }

    //Set max limit for uploading images
    if (files.length > 5) {
        files.length = 5;
        Swal.fire({
            title: 'error',
            html: 'Maximum amout of files are 5',
            icon: 'error',
        });
    }

    if (files.length > 0) {
        readURL(files, filecontainer);
    }
};


window.readURL = function (files, filecontainer) {
    //show reset button
    toggleImageInfo();

    for (var i = 0; i < files.length; i++) {
        //Load src of image
        var reader = new FileReader();
        reader.onload = function (e) {
            //create new img to display uploaded files
            var image = new Image();
            image.src = e.target.result;
            image.height = 60;
            image.classList.add('m-2');

            //Add image to container
            filecontainer.appendChild(image);
        };
        reader.readAsDataURL(files[i]);
    }
};


//Clicking the reset button to start image upload again
document.getElementById('resetImages').onclick = function () {
    //Empty current uploaded images
    document.getElementById('filImages').value = '';
    document.getElementById('previewImages').innerHTML = '';

    //hide reset button and show text
    toggleImageInfo();
};


//show or hide image image or show reset button
function toggleImageInfo() {
    document.getElementById('infoImages').classList.toggle('d-none');
    document.querySelector('label[for="filImages"]').classList.toggle('d-none');
    document.getElementById('resetImages').classList.toggle('d-none');
}


// Search and replace paramters in url
function replaceQueryParams(param, newval, search) {
    var regex = new RegExp('([?;&])' + param + '[^&;]*[;&]?');
    var query = search.replace(regex, '$1').replace(/&$/, '');

    return (query.length > 2 ? query + '&' : '?') + (newval ? param + '=' + newval : '');
}


//Fallback to bubble path if browser don't support it (ie)
function composedPath(el) {
    var path = [];

    while (el) {
        path.push(el);

        if (el.tagName === 'HTML') {
            path.push(document);
            path.push(window);

            return path;
        }

        el = el.parentElement;
    }
}

//Set isbn nummer equal to search when adding own book
$('#MyLibraryAddBook').on('shown.bs.modal', function () {

    var searchvalue = document.getElementById('search_isbn_name').value;

    if (!isNaN(searchvalue)) {
        document.getElementById('book_isbn').value = searchvalue;
    } else {
        document.getElementById('book_name').value = searchvalue;
    }
});

//Validate form
// Example starter JavaScript for disabling form submissions if there are invalid fields
(function () {
    'use strict';
    window.addEventListener('load', function () {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                } else {
                    //Call ajax instead submit
                    add_own_book(event);
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();